<template>
  <div class="flex flex-column full-height relative">
    <template v-if="routeMatchesComponent() && !contremarque">
      <div v-if="!loading" class="flex flex-column flex-auto full-height scrollable thin-scroll py3">
        <div v-for="activity in Object.keys(activitiesList)" :key="activity" class="flex flex-wrap border-bottom mb1 white-bg">
          <div class="flex-auto no-box flex flex-wrap action pointer" @click="redirectToSession(activity)">
            <div class="col-10 no-box pl2 flex items-center">
              <div class="col-12 pr2 no-box">
                <span class="block h5n bold">{{ activity }}</span>
              </div>
            </div>

            <div class="col-2 no-box flex justify-end">
              <i class="breadcrumb-arrow red bold flex items-center p2 icon-angle-right-icon"></i>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="contremarque">
      <div class="flex h5 bold col-12 center justify-center">
        Pour réserver, vous devez activer votre e-billet. Veuillez vous rendre à l’accueil du centre.
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { getCurrentInstance, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { routeIsCurrentComponent } from '@/mixins/utils';

export default {
  components: { },
  setup () {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const loading = computed(() => store.state.loadingContent);
    const contremarque = computed(() => store.state.contremarque);

    const activities = computed(() => store.state.activities || []);
    const activitiesList = computed(() => store.state.activitiesList || {});

    const redirectToSession = activity => {
      if (activities.value.length === 1 && activities.value[0].group !== 'NONE') {
        router.push({ name: 'GroupSessionsPlanner', params: { billet_uuid: route.params.billet_uuid } });
      } else {
        store.commit('setSelectedActivity', activities.value.filter(a => a.group === activity || a.name === activity));
        store.commit('setSelectedActivityKey', activity);
        store.commit('setSelected', activitiesList.value[activity]);
        router.push({ name: 'SessionsPlanner' });
      }
    };

    return {
      activitiesList,
      store,
      loading,
      redirectToSession,
      routeMatchesComponent,
      contremarque
    };
  }
};
</script>

<style lang="scss" scoped>
.action:hover .breadcrumb-arrow{
  color: white;
}
</style>
